import React from 'react';
import styled from 'styled-components';
import { COLOURS } from './Timeline._constants';
const Container = styled.div `
  width: 28px;
  height: 46px;
  padding-top: 15px;
  background-color: ${COLOURS.WHITE_10}
  text-align: center;
  cursor: pointer;
  z-index: 1;
`;
const ContainerArrow = styled.div `
  display: inline-block;
  position: relative;
  width: 0;
  height: 8px;
  margin: 0 auto;
  box-sizing: border-box;
`;
const ArrowRight = styled(ContainerArrow) `
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: -4px;
    top: 50%;
    margin-top: -5px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid ${COLOURS.RED_10};
  }
`;
const ArrowLeft = styled(ContainerArrow) `
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: -6px;
    top: 50%;
    margin-top: -5px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-right: 5px solid ${COLOURS.RED_10};
    border-bottom: 5px solid transparent;
    border-left: 5px solid transparent;
  }
`;
const TimelineTimelineMobileArrows = ({ arrow, className, handleClickArrow, }) => {
    return (React.createElement(Container, { onClick: (evt) => handleClickArrow(evt, arrow) },
        arrow === 'previous' && React.createElement(ArrowLeft, { className: className }),
        arrow === 'next' && React.createElement(ArrowRight, { className: className })));
};
export default TimelineTimelineMobileArrows;
